import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { CustomButton } from "@/components/ui/Buttons";
import { useAppSelector } from "@/redux/hooks/hooks";
import { useGetMeQuery } from "@/redux/feature/user/userApi";

import {
  useCheckTrialStatusQuery,
  useStartTrialMutation,
} from "@/redux/feature/trialPlan/trialPlanApi";

export default function AiTrialCard() {
  const { user } = useAppSelector((s) => s.auth);
  const email = user?.email || "";
  const { data: me } = useGetMeQuery(email, { skip: !email });

  // --- hooks
  const [startTrial] = useStartTrialMutation();
  const { data: trialData, refetch } = useCheckTrialStatusQuery(email, {
    skip: !email,
  });

  const [loading, setLoading] = useState(false);
  const active = trialData?.data?.active;
  const daysLeft = trialData?.data?.daysLeft || 0;

  const handleStartTrial = async () => {
    if (!email) return toast.error("Please sign in first.");
    setLoading(true);
    try {
      await startTrial({ email }).unwrap();
      toast.success("🎉 Free trial started successfully!");
      refetch();
    } catch (err: any) {
      console.error(err);
      toast.error(err?.data?.message || "Could not start trial");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto max-w-[820px] rounded-2xl border border-[#F1F2F9] bg-white ai-pricing-card-shadow">
      <div className="p-5 flex flex-col md:flex-row items-center justify-between gap-6 px-7 py-[24.5px]">
        <div className="space-y-2 flex-1">
          <h2 className="text-[24px] font-medium text-[#060B13] tracking-[-1%]">
            {active
              ? `Your free trial is active — ${daysLeft} day${
                  daysLeft === 1 ? "" : "s"
                } left`
              : "Start your free trial — 7 days of full access"}
          </h2>
          <p className="text-base text-[#363D4F]">
            Explore all features, track up to <b>3 products</b>, and add{" "}
            <b>10 competitors</b> — no credit card required.
          </p>
        </div>

        <div className="flex flex-col items-center gap-2">
          <img
            src={
              "https://assets.passionbits.io/public/client-dashboard/images/starter.webp"
            }
            alt="Free Trial"
            className="w-[180px] h-[100px] object-cover rounded-lg"
          />
          <CustomButton
            variant="outline"
            padding="8px"
            className="w-full"
            color="#170F49"
            border="1px solid #FF6600"
            fontSize="16px"
            fontWeight="500"
            disabled={loading || active}
            onClick={handleStartTrial}
          >
            {active
              ? `Trial Active (${daysLeft}d left)`
              : loading
              ? "Starting..."
              : "Start Free Trial"}
          </CustomButton>
        </div>
      </div>
    </div>
  );
}
